<template>
  <div v-if="loaded">
    <b-row>
      <b-col lg="12">
        <Mail
          ref="mail"
          :emails_list="mandat.emails"
          :attached_objects="object"
          :free_mail="false"
          :body="body"
          :subject="subject"
          @close="$emit('close', $event)"
        >
        </Mail>
      </b-col>
      
    </b-row>
  </div>
</template>

<script>
import documents from "@/services/documents";
import Mail from "@/components/Mail.vue";
export default {
  name: "RappelAvocatMail",
  components: {
    Mail,
  },
  props: {
    mandat_id: [Number, String],
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      
      mandat: {},
      huissierID: null,
      componentKey: 0,
      ref: "",
      adr: "",
      dp: false,
      body: "",
      loaded: false,
      subject: "",
      object: [
        {
          object: "RappelAvocat",
          id: this.mandat_id,
          ref: '',
          dp: false,
          adr: '',
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
   
    load() {
      documents
        .get_single(
          "mandat_rappel_avocat",
          this.$props.mandat_id
        )
        .then((response) => {
          this.mandat = response.data;
          this.body = this.mandat.body;
          this.subject = this.mandat.subject;
          this.loaded = true;
          
        });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>